export default function textTrim(text, length, eclipse = "...") {
    if (!text) return "";
    return text.length > length
        ? text.slice(0, length).trim() + eclipse
        : text.trim();
}
